module.exports = __webpack_public_path__ + "static/media/taichong.339382ad.mp3";